module.exports = __webpack_public_path__ + "files/8b6ee2319bfde6aa92dbb20d4ea0c50f.png";